import React from 'react'
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/core'

import { Button } from '../Button'
import { Heading } from '../Heading'
import { CloseButton } from '../CloseButton'

export { ModalFooter }

export interface ModalProps extends ModalContentProps {
  isVisible?: boolean
  onClose?: () => void
  heading?: string | React.ReactNode
  initialFocusRef?: React.RefObject<HTMLElement>
  hideClose?: boolean
  bodyProps?: Object
}

export const Modal = ({
  isVisible,
  onClose,
  children,
  heading,
  initialFocusRef,
  hideClose,
  bodyProps,
  ...restProps
}: ModalProps) => {
  return (
    <ChakraModal
      isOpen={isVisible}
      onClose={onClose}
      initialFocusRef={initialFocusRef}
      closeOnOverlayClick={!hideClose}
      closeOnEsc={!hideClose}
    >
      <ModalOverlay />

      <ModalContent {...restProps}>
        {heading && (
          <ModalHeader>
            <Heading>{heading}</Heading>
          </ModalHeader>
        )}

        {!hideClose && <ModalCloseButton as={CloseButton} />}

        <ModalBody {...bodyProps}>{children}</ModalBody>

        {/* <ModalFooter>
          <Button variantColor="pink" mr={3} onClick={onClose}>
            Close
          </Button>

          <Button variant="ghost">Secondary Action</Button>
        </ModalFooter> */}
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal
